import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Spin } from 'antd';
import FirmaElectronica from 'views/Tramites/components/FirmaElectronica';
import FormSubmitControls from 'components/FormSubmitControls';
import { patchFirmarTramite } from 'api/tramites';
import { generateValues } from 'views/Tramites/GPM/components/ModalLog';
import { solicitantesEnum, tiposDePasosEnum } from 'views/Tramites/GPM/enums';

const ModalFirmarTramites = ({
  visible,
  tramites,
  onCancel,
  callback,
  pasos,
}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    const promises = tramites.map((tramite) => {
      const _pasos = pasos.filter((paso) => {
        if (paso.plantilla_de_tramite !== tramite.plantilla) {
          return false;
        }
        if (paso.tipo_de_paso === tiposDePasosEnum.MODIFICACION_SOLICITANTE) {
          const tipoDePadronSolicitante = tramite.solicitante_ciudadano
            ? solicitantesEnum.CIUDADANO : solicitantesEnum.CONTRIBUYENTE;
          return paso.configuracion_de_padron.padron?.id === tipoDePadronSolicitante;
        }
        return true;
      });
      const pasoActual = _pasos.find((p) => p.id === tramite.paso);
      const [valuesLog] = generateValues(pasoActual, _pasos, true);
      if (valuesLog) {
        valuesLog.comentario = 'Firmado por medio de firmado masivo';
        valuesLog.tramite = tramite.id;
        return patchFirmarTramite(tramite, { paso: pasoActual.id, ...values }, valuesLog);
      }
      return null;
    }).filter((p) => p);
    const responses = await Promise.all(promises);
    callback(responses.filter((r) => r));
    if (responses.some((r) => r)) {
      onCancel();
    }
    setLoading(false);
  };

  return (
    <Modal
      visible={visible}
      title={(
        <FormSubmitControls
          label="Firmar"
          onCancel={onCancel}
          onFinish={form.submit}
          loading={loading}
        />
      )}
      closable={false}
      keyboard={!loading}
      footer={null}
    >
      <Spin spinning={loading} tip="Loading...">
        <Form form={form} onFinish={onFinish} layout="vertical">
          <FirmaElectronica modal />
        </Form>
      </Spin>
    </Modal>
  );
};

ModalFirmarTramites.propTypes = {
  tramites: PropTypes.arrayOf(PropTypes.shape({})),
  pasos: PropTypes.arrayOf(PropTypes.shape({})),
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
};

ModalFirmarTramites.defaultProps = {
  tramites: [],
  pasos: [],
  visible: false,
};

export default ModalFirmarTramites;
